import React, { useCallback } from 'react'

import { DataType, OrderType } from '@/types'

import THeadCol from './THeadCol'

export interface Column {
  key: string
  type?: string
  sortKey?: string
  dataType?: DataType
}

interface ITableHeader {
  onSort?: (key?: string, orderBy?: OrderType, dataType?: DataType) => void
  columns: Column[]
  orderedBy?: string
}

const TableHeader: React.FC<ITableHeader> = ({
  onSort,
  columns,
  orderedBy,
}) => {
  const _onSort = useCallback(
    (key?: string, dataType?: DataType) => {
      if (!key) return
      const _orderBy = orderedBy === 'asc' ? 'desc' : 'asc'
      onSort?.(key, _orderBy, dataType)
    },
    [onSort, orderedBy],
  )

  return (
    <thead>
      <tr>
        {columns.map(col => {
          return (
            <THeadCol
              key={col.key}
              type={col.type}
              colName={col.key}
              onClick={() => _onSort?.(col.sortKey, col.dataType)}
            />
          )
        })}
      </tr>
    </thead>
  )
}

export default TableHeader
